import React from "react";
import { useTranslation } from "react-i18next";
import { useJournalReminder } from "./useJournalReminder";

const JournalReminderControls = ({ variant = "menu" }) => {
  const { t } = useTranslation();
  const { enabled, time, setEnabled, setTime, requestPermission, permission } = useJournalReminder();

  const onToggle = async (next) => {
    if (next) {
      const result = await requestPermission();
      if (result === "denied" || result === "unsupported") {
        setEnabled(false);
        return;
      }
    }
    setEnabled(next);
  };

  if (variant === "mobile") {
    return (
      <div className="m-settings-card">
        <h3 className="m-settings-heading">{t("journalReminder")}</h3>
        <p className="m-settings-export-desc">{t("journalReminderDesc")}</p>
        <div className="m-settings-row">
          <span>{t("enableReminder")}</span>
          <label className="journal-reminder-switch">
            <input
              type="checkbox"
              checked={enabled}
              onChange={(e) => onToggle(e.target.checked)}
            />
            <span className="journal-reminder-slider" />
          </label>
        </div>
        <div className="m-settings-row">
          <span>{t("journalReminderTime")}</span>
          <input
            type="time"
            className="journal-reminder-time"
            value={time}
            onChange={(e) => setTime(e.target.value)}
            disabled={!enabled}
            aria-label={t("journalReminderTime")}
          />
        </div>
        {permission === "denied" && (
          <p className="m-settings-export-desc">{t("notificationsBlocked")}</p>
        )}
      </div>
    );
  }

  return (
    <div className="hamburger-reminder">
      <div className="hamburger-row">
        <span className="hamburger-label">{t("journalReminder")}</span>
        <label className="journal-reminder-switch">
          <input
            type="checkbox"
            checked={enabled}
            onChange={(e) => onToggle(e.target.checked)}
            aria-label={t("enableReminder")}
          />
          <span className="journal-reminder-slider" />
        </label>
      </div>
      <p className="hamburger-hint">{t("journalReminderDesc")}</p>
      <div className="hamburger-row">
        <span className="hamburger-label">{t("journalReminderTime")}</span>
        <input
          type="time"
          className="journal-reminder-time"
          value={time}
          onChange={(e) => setTime(e.target.value)}
          disabled={!enabled}
          aria-label={t("journalReminderTime")}
        />
      </div>
      {permission === "denied" && (
        <p className="hamburger-hint">{t("notificationsBlocked")}</p>
      )}
    </div>
  );
};

export default JournalReminderControls;
